/**
 * Функция, создающая задержку
 * @param ms - время задержки
 * @returns Promise<undefined>
 */
export function delay(ms: number): Promise<undefined> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
